
import { useState } from 'react';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          {/* ロゴ */}
          <div className="flex items-center">
            <a href="#" className="flex items-center gap-3 cursor-pointer">
              <div className="bg-green-600 w-12 h-12 rounded-lg flex items-center justify-center">
                <i className="ri-home-heart-line text-white text-2xl w-6 h-6 flex items-center justify-center"></i>
              </div>
              <div>
                <h1 className="text-2xl font-bold text-gray-800">遺品整理のハセガワ</h1>
                <p className="text-xs text-gray-600">心に寄り添う整理サービス</p>
              </div>
            </a>
          </div>

          {/* デスクトップナビゲーション */}
          <nav className="hidden lg:flex items-center gap-8">
            <a 
              href="#services" 
              className="text-gray-700 hover:text-green-600 font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              サービス内容
            </a>
            <a 
              href="#reasons" 
              className="text-gray-700 hover:text-green-600 font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              選ばれる理由
            </a>
            <a 
              href="#pricing" 
              className="text-gray-700 hover:text-green-600 font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              料金表
            </a>
            <a 
              href="#area" 
              className="text-gray-700 hover:text-green-600 font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              対応エリア
            </a>
            <a 
              href="#company" 
              className="text-gray-700 hover:text-green-600 font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              会社概要
            </a>
          </nav>

          {/* モバイルメニューボタン */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden text-gray-700 hover:text-green-600 transition-colors cursor-pointer"
            aria-label="メニュー"
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-3xl w-8 h-8 flex items-center justify-center`}></i>
          </button>
        </div>

        {/* モバイルメニュー */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col gap-4">
              <a 
                href="#services" 
                onClick={() => setIsMenuOpen(false)}
                className="text-gray-700 hover:text-green-600 font-medium transition-colors cursor-pointer py-2 whitespace-nowrap"
              >
                サービス内容
              </a>
              <a 
                href="#reasons" 
                onClick={() => setIsMenuOpen(false)}
                className="text-gray-700 hover:text-green-600 font-medium transition-colors cursor-pointer py-2 whitespace-nowrap"
              >
                選ばれる理由
              </a>
              <a 
                href="#pricing" 
                onClick={() => setIsMenuOpen(false)}
                className="text-gray-700 hover:text-green-600 font-medium transition-colors cursor-pointer py-2 whitespace-nowrap"
              >
                料金表
              </a>
              <a 
                href="#area" 
                onClick={() => setIsMenuOpen(false)}
                className="text-gray-700 hover:text-green-600 font-medium transition-colors cursor-pointer py-2 whitespace-nowrap"
              >
                対応エリア
              </a>
              <a 
                href="#company" 
                onClick={() => setIsMenuOpen(false)}
                className="text-gray-700 hover:text-green-600 font-medium transition-colors cursor-pointer py-2 whitespace-nowrap"
              >
                会社概要
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
